/*
 * One device per table row (the mockup's `.table`): 48px rows, hairlines between them, the action
 * in the last cell so the eye and the tab order agree about where it is.
 */
.row td {
  block-size: 48px;
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  vertical-align: middle;
}

.row:last-child td {
  border-block-end: 0;
}

.row:hover {
  background: var(--surface-sunken);
}

.device {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  font-weight: var(--font-weight-medium);
}

.address,
.moment {
  color: var(--text-muted);
  /* The mockup's `.meta`: 12px secondary text beside the 13px device. */
  font-size: var(--font-size-12);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.actions {
  text-align: end;
  white-space: nowrap;
}
